import { toast } from '@mcdougald/ui/src';
import { type ReactNode, useState } from 'react';

type CopyOptions = {
  text: string;
  timeout?: number;
  successMessage?: ReactNode;
  errorMessage?: ReactNode;
};

export const useCopyToClipboard: () => [
  (options: CopyOptions) => Promise<void>,
  boolean,
] = (): [(options: CopyOptions) => Promise<void>, boolean] => {
  const [isCopied, setIsCopied] = useState(false);
  // const t = useTranslations();

  const copy = async ({
    text,
    timeout,
    successMessage,
    errorMessage,
  }: CopyOptions): Promise<void> => {
    if (isCopied) return;

    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      // toast.success(successMessage ?? t('hook.copy-to-clipboard.copied'));
      toast.success(successMessage ?? 'Successfully copied to clipboard');

      setTimeout(() => setIsCopied(false), timeout ?? 2000);
    } catch {
      // toast.error(errorMessage ?? t('hook.copy-to-clipboard.error'));
      toast.error(errorMessage ?? 'Error copying to clipboard');
    }
  };

  return [copy, isCopied];
};
